import { MarkerPin01, MessageDotsSquare } from '@untitled-ui/icons-react';
import React from 'react';

import { BookingUserProfileModel } from 'src/services/booking';
import { SiteBaseModel } from 'src/services/site';
import { clinicName, doctorAvatarSrc, doctorName } from 'src/utils/name';
import { SentenceList } from 'src/utils/sentenceList';

type Props = {
    doctor: BookingUserProfileModel;
    site?: SiteBaseModel;
    actions?: React.ReactNode;
    gender?: string;
};

// expected "M" or "F"
function printGender(genderCode: string) {
    switch (genderCode) {
        case 'M':
            return 'Male';
        case 'F':
            return 'Female';
        default:
            return undefined;
    }
}

export function DoctorCard({ doctor, site, actions, gender }: Props) {
    return (
        <div className="border-grey-300 flex flex-col gap-5 rounded-lg border p-4 sm:flex-row">
            <div className="flex flex-1 flex-col gap-2.5">
                <div className="flex flex-row gap-2.5">
                    <div className="flex w-16 flex-col items-center gap-1 sm:w-24">
                        <img
                            className="border-grey-200 size-16 rounded-lg border object-cover sm:size-24"
                            src={doctorAvatarSrc(doctor)}
                        />
                        {doctor.umbracoPageUrl && (
                            <a
                                target="_blank"
                                href={`${import.meta.env.VITE_MYHEALTH_WEBSITE}${doctor.umbracoPageUrl}`}
                                className="text-primary hidden w-fit text-center font-semibold sm:block"
                            >
                                View profile
                            </a>
                        )}
                    </div>
                    <div className="">
                        <h3 className="text-lg font-semibold text-gray-700">{doctorName(doctor)}</h3>
                        <p className="text-sm font-medium text-gray-700">
                            {[doctor.umbracoRole, printGender(doctor.gender ?? gender)].filter((x) => x).join(', ')}
                        </p>
                        <p className="text-xs font-medium text-gray-500">{doctor.umbracoQualification}</p>
                        <ul className="mt-1 hidden space-y-1 text-sm font-normal text-gray-500 sm:block">
                            {doctor.umbracoLanguages?.length && (
                                <li className="flex flex-row">
                                    <MessageDotsSquare className="mr-2.5 size-5" />
                                    Speaks {SentenceList(doctor.umbracoLanguages)}
                                </li>
                            )}
                            {site && (
                                <li className="flex flex-row">
                                    <MarkerPin01 className="mr-2.5 size-5" />
                                    {clinicName(site)}
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                <ul className="mt-1 block space-y-1 text-sm font-normal text-gray-500 sm:hidden">
                    {doctor.umbracoLanguages?.length && (
                        <li className="flex flex-row">
                            <MessageDotsSquare className="mr-2.5 size-5" />
                            Speaks {SentenceList(doctor.umbracoLanguages)}
                        </li>
                    )}
                    {site && (
                        <li className="flex flex-row">
                            <MarkerPin01 className="mr-2.5 size-5" />
                            {clinicName(site)}
                        </li>
                    )}
                </ul>
            </div>
            {actions && <div className="flex flex-none flex-col justify-center gap-3 text-center">{actions}</div>}
        </div>
    );
}
